import { CLEAR_TROLLEY_ERRORS } from 'redux/modules/trolley-errors/actions/types';

export default () => ({
  type: CLEAR_TROLLEY_ERRORS,
});
